import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Section, SectionHeader } from "@/components/marketing/Section";
import { Button } from "@/components/ui/Button";
import { AnimatedContainer } from "@/components/ui/motion";
import WaveText from "@/components/ui/wave-text";

export function NotFound() {
  const { t } = useTranslation();
  const _location = useLocation();
  const home = "/";

  return (
    <Section>
      <AnimatedContainer className="text-center">
        <p
          aria-hidden
          className="font-mono text-8xl font-semibold tracking-tighter text-primary/40 md:text-9xl"
        >
          <WaveText text="404" />
        </p>
      </AnimatedContainer>
      <SectionHeader
        title={t("notFound.title")}
        subtitle={t("notFound.body")}
        align="center"
        className="mt-6"
      />
      <div className="mt-10 flex justify-center">
        <Button to={home}>{t("notFound.home")}</Button>
      </div>
    </Section>
  );
}
